import React from "react";
import CategoryTag from "./category-tag";
import Img from "gatsby-image";
import { Link } from "gatsby";

const ArticleListItem = ({ article }) => {
  const { title, date, tags, image } = article.frontmatter;

  return (
    <div
      className="
      md:flex
      md:flex-wrap 
      md:justify-between 
      md:items-center
      mb-12"
    >
      <div className=" md:w-64 ma-w-sm mb-4 md:mr-8 ">
        <Link to={`/${article.fields.slug}`}>
          <Img
            className="rounded shadow-md "
            fluid={image.childImageSharp.fluid}
          />
        </Link>
      </div>

      <div className=" md:flex-1 md:w-3/4  p-4">
        <div className="mb-8 pb-1 border-b border-grey-lightest">
          <h3 className="mb-4 text-grey-dark">
            <Link
              className="no-underline text-grey-light hover:text-grey-lighter"
              to={`/${article.fields.slug}`}
            >
              {title}
            </Link>
          </h3>
          <div className="flex-distribute-horizontally items-center">
            <span className="mb-2 md:mb-1 lg:mb-0 text-grey-light text-sm italic">
              Publicado en: {date}
            </span>
            <ul className="flex-distribute-horizontally items-center list-reset">
              {tags.map(tag => {
                return <CategoryTag key={article.id} name={tag} />;
              })}
            </ul>
          </div>
        </div>
        <p className="leading-normal mb-4 text-grey-light">{article.excerpt}</p>
        <Link className="link" to={`/${article.fields.slug}`}>
          Leer artículo
        </Link>
      </div>
    </div>
  );
};

export default ArticleListItem;
